import React from 'react';
import { DeploymentDate } from '../../types/types';

interface DeploymentSelectorProps {
  deploymentDates: DeploymentDate[];
  selectedDate: string | null;
  setSelectedDate: (date: string) => void;
  setSelectedDeployment: (deploymentName: string) => void;
}

export default function DeploymentSelector({
  deploymentDates,
  selectedDate,
  setSelectedDate,
  setSelectedDeployment,
}: DeploymentSelectorProps) {
  const sortedDates = [...deploymentDates].sort((a, b) =>
    a.date.localeCompare(b.date)
  );

  return (
    <div className="flex flex-wrap justify-center gap-2 my-4">
      {sortedDates.map(({ date, label }, index) => (
        <button
          key={date}
          className={`px-3 py-1 text-xs rounded-full transition-colors ${
            selectedDate === date
              ? 'bg-blue-600 text-white'
              : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-blue-400'
          }`}
          onClick={() => {
            setSelectedDate(date);
            setSelectedDeployment(`Deployment_${index + 1}`);
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
